<template>
  <article v-editable="blok" class="article-wrapper">
    <component :is="pageBannerComponent" v-if="pageBanner" :blok="pageBanner" />
    <template v-if="blocks">
      <component
        :is="block.component"
        v-for="block in blocks"
        :key="block._uid"
        :blok="block"
      />
    </template>
    <ContentSubscribe v-if="!pageContainsSubscriptionForm" />
  </article>
</template>

<script setup lang="ts">
import type { LandingPageStoryblok } from '~/types/storyblok'

const props = defineProps<{ blok: LandingPageStoryblok }>()
const {
  pageBanner,
  pageBannerComponent,
  blocks,
  pageContainsSubscriptionForm,
} = useStoryContent(toRefs(props))
</script>

<style lang="less">
.page.campaign {
  h1,
  h2 {
    font-size: @28px !important;

    @media @tablet {
      font-size: @38px !important;
    }
  }
  h3 {
    font-size: @22px !important;

    @media @tablet {
      font-size: @28px !important;
    }
  }
  h4 {
    font-size: @20px !important;

    @media @tablet {
      font-size: @24px !important;
    }
  }
  h5 {
    font-size: @18px !important;

    @media @tablet {
      font-size: @20px !important;
    }
  }
  h6 {
    font-size: @16px !important;

    @media @tablet {
      font-size: @18px !important;
    }
  }

  &.arabic {
    .page-intro__dropdown-content,
    .page-intro__content-text,
    .content {
      direction: rtl;

      blockquote {
        &::after {
          content: '\201C';
        }

        &::before {
          content: '\201D';
          margin-left: 0.2rem;
        }
      }
    }
  }
}
</style>
